import { API_ENDPOINTS } from '../../../api/endpoints';
import { ActorType, } from '../types';
export class AssistantAPI {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    async createConversation(usageContext, agentMode) {
        const request = Object.assign(Object.assign({}, (usageContext && { usage_context: usageContext })), (agentMode !== undefined && { agent_mode: agentMode }));
        return this.apiClient.post(API_ENDPOINTS.ASSISTANT.CONVERSATIONS, request);
    }
    async getConversation(conversationId) {
        return this.apiClient.get(API_ENDPOINTS.ASSISTANT.CONVERSATION(conversationId));
    }
    async sendMessage(conversationId, message, model) {
        const request = {
            message,
            user_id: '',
            user_type: ActorType.ADMIN,
            model,
        };
        await this.apiClient.post(API_ENDPOINTS.ASSISTANT.CONVERSE(conversationId), request, {
            responseType: 'text',
        });
    }
    async deleteMessage(messageId) {
        return this.apiClient.delete(API_ENDPOINTS.ASSISTANT.MESSAGE(messageId));
    }
    async setMessageFeedback(messageId, conversationId, isUpvoted, feedbackComment) {
        await this.apiClient.post(API_ENDPOINTS.ASSISTANT.MESSAGE_FEEDBACK(messageId), {
            conversation_id: conversationId,
            is_upvoted: isUpvoted,
            feedback_comment: feedbackComment,
        });
    }
    async getConversations() {
        return this.apiClient.get(API_ENDPOINTS.ASSISTANT.CONVERSATIONS);
    }
    async listConversations(limit = 50, offset = 0) {
        return this.apiClient.get(API_ENDPOINTS.ASSISTANT.CONVERSATIONS, {
            params: { limit, offset },
        });
    }
    async deleteConversation(conversationId) {
        return this.apiClient.delete(API_ENDPOINTS.ASSISTANT.CONVERSATION(conversationId));
    }
    async updateConversationTitle(conversationId, title) {
        const request = { title };
        await this.apiClient.patch(API_ENDPOINTS.ASSISTANT.CONVERSATION_TITLE(conversationId), request);
    }
    async updateConversationAgentMode(conversationId, agentMode) {
        const messages = await this.apiClient.patch(API_ENDPOINTS.ASSISTANT.CONVERSATION_AGENT_MODE(conversationId), { agent_mode: agentMode });
        return messages !== null && messages !== void 0 ? messages : [];
    }
}
